<template>
  <!-- 优惠券查看详情 -->
  <div class="couponDetail">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title"></page-header>
    <!-- 优惠券详情表单 -->
    <el-scrollbar
      style="
        height: calc(100% - 60px);
        padding-top: 20px;
        box-sizing: border-box;
      "
    >
      <el-form :model="couponData" label-position="rigth" label-width="120px">
        <div class="form-item-wrap">
          <el-form-item label="优惠券编号" prop="couponCode">
            <el-input
              v-model="couponData.couponCode"
              readonly
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="优惠券名称" prop="couponName">
            <el-input
              v-model="couponData.couponName"
              readonly
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </div>

        <div class="form-item-wrap">
          <el-form-item label="渠道平台" prop="typetitle">
            <el-input
              v-model="couponData.typetitle"
              readonly
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="优惠券类型" prop="receivingType1">
            <el-input
              v-model="couponData.receivingType1"
              readonly
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap" v-show="couponData.receivingType == 4">
          <el-form-item label="条件目标(件数)" prop="Num">
            <el-input
              v-model="couponData.Num"
              readonly
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap" v-show="couponData.receivingType == 5">
          <el-form-item label="条件目标(金额)" prop="AllAmount">
            <el-input
              v-model="couponData.AllAmount"
              readonly
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <!-- 范围商品分组显示 -->
          <el-form-item
            v-if="couponData.SceneCoding == 0"
            label="范围"
            prop="SceneCoding"
          >
            <el-input readonly style="width: 200px" value="全场商品"></el-input>
          </el-form-item>
          <!-- 范围商品分组显示 -->
          <el-form-item
            v-if="couponData.SceneCoding == 4"
            label="范围"
            prop="SceneCoding"
          >
            <el-input readonly style="width: 200px" value="商品分组"></el-input>
            <el-input
              readonly
              style="width: 200px; margin-left: 10px"
              v-model="couponData.SceneName"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-else-if="couponData.SceneCoding == 3"
            label="范围"
            prop="SceneCoding"
          >
            <el-input readonly style="width: 200px" value="独立商品"></el-input>
            <el-input
              readonly
              style="width: 200px; margin-left: 10px"
              v-model="couponData.SceneName"
            ></el-input>
          </el-form-item>
          <el-form-item v-else label="范围" prop="SceneCoding">
            <el-input
              v-show="couponData.SceneCoding == 1"
              readonly
              style="width: 200px"
              value="分类商品"
            ></el-input>
            <el-input
              v-show="couponData.SceneCoding == 2"
              readonly
              style="width: 200px"
              value="品牌商品"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="优惠券总数" prop="couponsNumber">
            <el-input
              v-model="couponData.couponsNumber"
              readonly
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户可领取次数" prop="couponsNumber">
            <el-input
              v-model="couponData.singleNumber"
              readonly
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="领取时间" prop="startingTime">
            <el-input
              v-model="couponData.startDate"
              readonly
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="结束时间" prop="endTime">
            <el-input
              v-model="couponData.endDate"
              readonly
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="使用时间" prop="startingTime">
            <el-input
              v-model="couponData.startingTime"
              readonly
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="结束时间" prop="endTime">
            <el-input
              v-model="couponData.endTime"
              readonly
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="规则类型" prop="coupontype">
            <el-input
              v-model="couponData.coupontype"
              readonly
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="规则详情" prop="types">
            <el-input
              v-show="couponData.types == 0"
              readonly
              style="width: 200px"
              value="无条件优惠"
            ></el-input>
            <el-input
              v-show="couponData.types == 0"
              readonly
              style="width: 200px; margin-left: 10px"
              v-model="couponData.deduction"
            ></el-input>
            <el-input
              v-show="couponData.types == 1"
              readonly
              style="width: 200px"
              value="条件目标(金额) 金额"
            ></el-input>
            <el-input
              v-show="couponData.types == 1"
              readonly
              style="width: 200px; margin-left: 10px"
              v-model="couponData.deduction"
            ></el-input>
            <el-input
              v-show="couponData.types == 2"
              readonly
              style="width: 200px"
              value="优惠折扣"
            ></el-input>
            <el-input
              v-show="couponData.types == 2"
              readonly
              style="width: 200px; margin-left: 10px"
              v-model="couponData.discount"
            ></el-input>
            <el-input
              v-show="couponData.types == 3"
              readonly
              style="width: 200px"
              value="条件目标(金额) 赠品"
            ></el-input>
            <el-input
              v-show="couponData.types == 3"
              readonly
              style="width: 200px; margin-left: 10px"
              v-model="couponData.fullAmount"
            ></el-input>
            <el-input
              v-show="couponData.types == 4"
              readonly
              style="width: 200px"
              value="条件目标(件数) 赠品"
            ></el-input>
            <el-input
              v-show="couponData.types == 4"
              readonly
              style="width: 200px; margin-left: 10px"
              v-model="couponData.ProName"
            ></el-input>
            <el-input
              v-show="couponData.types == 5"
              readonly
              style="width: 200px"
              value="免邮"
            ></el-input>
            <el-input
              v-show="couponData.types == 6"
              readonly
              style="width: 200px"
              value="条件目标(件数) 优惠折扣"
            ></el-input>
            <el-input
              v-show="couponData.types == 6"
              readonly
              style="width: 200px; margin-left: 10px"
              v-model="couponData.discount"
            ></el-input>
            <el-input
              v-show="couponData.types == 7"
              readonly
              style="width: 200px"
              value="条件目标(件数) 优惠金额"
            ></el-input>
            <el-input
              v-show="couponData.types == 7"
              readonly
              style="width: 200px; margin-left: 10px"
              v-model="couponData.discount"
            ></el-input>
            <el-input
              v-show="couponData.types == 9"
              readonly
              style="width: 200px"
              value="条件目标(金额) 优惠折扣"
            ></el-input>
            <!-- <el-input v-show="couponData.types == 9" readonly style="width: 200px;margin-left: 10px;"
              v-model="couponData.discount"></el-input> -->
            <span style="margin-left: 10px" v-show="couponData.types == 9"
              >满{{ couponData.fullAmount }}打{{
                couponData.discount * 10
              }}折</span
            >
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="客户控销" prop="">
            <el-select
              disabled
              style="width: 200px"
              v-model="couponData.ExcludeType"
            >
              <el-option label="无限制" value="0"></el-option>
              <el-option label="白名单" value="1"></el-option>
              <el-option label="黑名单" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分组名称" prop="">
            <el-input
              type="textarea"
              readonly
              style="width: 400px; margin-left: 10px"
              :value="couponData.ExcludeName"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="区域控销" prop="">
            <el-select
              disabled
              style="width: 200px"
              v-model="couponData.qykzlx"
            >
              <el-option label="无限制" value="0"></el-option>
              <el-option label="白名单" value="1"></el-option>
              <el-option label="黑名单" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区域名称" prop="">
            <el-input
              type="textarea"
              readonly
              style="width: 400px; margin-left: 10px"
              :value="couponData.qykzname"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="支付方式" prop="">
            <div class="formwrapitem">
              <div
                v-for="(item, index) in payTypeList"
                class="item"
                :key="index"
              >
                <span v-if="item.iShow">{{ item.PayType }}</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="客户类型" prop="">
            <div class="formwrapitem">
              <div
                v-for="(item, index) in rangeTypeList"
                class="item"
                :key="index"
              >
                <span v-if="item.iShow">{{ item.clienttype }}</span>
              </div>
            </div>
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  name: "couponDetail",
  data() {
    return {
      couponId: "",
      couponData: {},
      payTypeList: [],
      rangeTypeList: [],
    };
  },
  mounted() {
    this.entId = window.localStorage.getItem("entId");
    this.getPayType();
    this.getClientData();
    //接收role传递参数
    let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
    if (prams) {
      //执行编辑，没有注册
      this.couponId = prams.couponId;
      this.getCouponInfo();
    }
  },
  methods: {
    /**返回 */
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    // 获取优惠券详情
    getCouponInfo() {
      let data = {
        type: "PC_GetCouponDetail",
        couponCode: this.couponId,
      };
      let proc = "PC_Coupon"; //存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method: "post",
        url:
          "order/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          // console.log(res);
          if (res.flag == 0) {
            this.couponData = res.table0[0];
            if (res.table1 !== undefined) {
              let tableList = res.table1;
              let qykzname = [];
              let qykzname1 = [];
              let ExcludeName = [];
              let ExcludeName1 = [];
              let paytype = [];

              paytype = this.couponData.PayType.split(",");
              this.payTypeList.forEach((item) => {
                paytype.forEach((j) => {
                  if (item.PayId == j) {
                    item.iShow = true;
                  }
                });
              });
              let customertype = [];
              customertype = this.couponData.customertype.split(",");
              this.rangeTypeList.forEach((item) => {
                customertype.forEach((j) => {
                  if (item.TypeID == j) {
                    item.iShow = true;
                  }
                });
              });
              tableList.forEach((element) => {
                if (element.Limit == 2 && element.LimitType == "Area") {
                  qykzname.push(element.LimitName);
                }
                if (element.Limit == 1 && element.LimitType == "Area") {
                  qykzname1.push(element.LimitName);
                }
                if (element.Limit == 2 && element.LimitType == "Client") {
                  ExcludeName.push(element.LimitName);
                }
                if (element.Limit == 1 && element.LimitType == "Client") {
                  ExcludeName1.push(element.LimitName);
                }
              });
              if (this.couponData.qykzlx == 1) {
                this.couponData.qykzname = qykzname1.join(",");
              } else if (this.couponData.qykzlx == 2) {
                this.couponData.qykzname = qykzname.join(",");
              } else {
                this.couponData.qykzname = "";
              }
              if (this.couponData.ExcludeType == 1) {
                this.couponData.ExcludeName = ExcludeName1.join(",");
              } else if (this.couponData.ExcludeType == 2) {
                this.couponData.ExcludeName = ExcludeName.join(",");
              } else {
                this.couponData.ExcludeName = "";
              }
            }
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**获取支付方式 */
    getPayType() {
      this.$request({
        url: "Base/GetEntPayTypeList",
        method: "post",
        data: {
          entId: this.entId,
        },
      })
        .then((res) => {
          if (res.success) {
            this.payTypeList = res.list.map((item) => {
              return {
                PayType: item.PayType,
                PayId: item.PayId + "", //转换为字符串
              };
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取客户类型
    getClientData() {
      let proc = "Proc_Admin_CustomerList"; //存储过程名
      let type = "ReturnList";
      let json = {
        type: "CustomType",
      };
      this.$requestSys({
        method: "post",
        url:
          "coupon/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(json)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.rangeTypeList = res.data;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.couponDetail {
  width: 100%;
  height: 100%;
}
.formwrapitem {
  display: flex;
}
.item {
  margin-left: 20px;
  color: #000;
}
</style>
